import * as imagesLoaded from 'imagesloaded'
import GsapSmoothScroll from './class/GsapSmoothScroll'
import gsap from 'gsap'
import { ScrollTrigger , ScrollToPlugin } from 'gsap/all'

import common from './common'
import index from './index'
import blog from './blog'
import facility from './facility'
import job from './job'
import staff from './staff'
import company from './company'
import service from './service'
import act from './act'
import usevue from './usevue'
gsap.registerPlugin(ScrollToPlugin)

let smoother
document.addEventListener('DOMContentLoaded', function() {
  imagesLoaded(document.getElementById('app'), ()=>{
    usevue()

    const loading = document.getElementById('loading')
    if(loading){
      loading.classList.add('remove')
      init()
      index()
      setTimeout( ()=> {
        loading.remove()
      },1000)
    }else{
      init()
    }
  })
});

function init(){
  if(window.innerWidth > 1119){
    smoother = new GsapSmoothScroll("#scrollArea", null, 1.6)
  }
  setProp()
  common()
  blog()
  act()
  facility()
  job()
  staff()
  company()
  service()
  require("fslightbox")

  changePageNavi()
  smoothScrollToTargetIfHashExists()
}

function setProp(){
  if(smoother != null){
    document.documentElement.style.setProperty('--screen', `${smoother.getOffsets()}px`)
  }else{
    cancelAnimationFrame(setProp)
  }
  requestAnimationFrame(setProp)
}

function smoothScrollToTargetIfHashExists() {
  const hash = window.location.hash;
  
  if (hash && hash !== "#") {
    const targetElement = document.getElementById(hash.split("#")[1]);
    if (targetElement) {
      scrollToAnimated(targetElement)
    }
  }
}

function scrollToAnimated(targetElement) {
  const headerHeight = document.getElementById('site-header').offsetHeight;
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
  gsap.to(window, { duration: 0.8, scrollTo: targetPosition });
}


function changePageNavi(){
  let pagenaviLinks = document.querySelectorAll('.wp-pagenavi a');
  pagenaviLinks.forEach(function(link) {
    link.href += '#Result';
  });
}
